import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import Timeline from "./Timeline.js";
import axios from "axios";
import { SERVER_URL } from "../../config/config.js";

const getEarliestSelectableDate = () => {
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() + 2);

  while (date.getDay() === 0 || date.getDay() === 6) {
    date.setDate(date.getDate() + 1);
  }

  return date;
};

const Calendary = (props) => {
  const [value, setValues] = useState(getEarliestSelectableDate);
  const [display, setDisplay] = useState(false);
  const [selectRange, setSelectedRange] = useState([]);
  const earliestSelectableDate = getEarliestSelectableDate();
  // const isTodaySelected =
  //   value instanceof Date &&
  //   value.toDateString() === new Date().toDateString();
  const getDate = async () => {
    const selectedDate = new Date(value);
    const formattedDate = selectedDate.toLocaleDateString("en-CA");
    axios
      .post(
        `${SERVER_URL}/nirantara/meeting/schedule`,
        { date: formattedDate },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer your_token_here", // Example
          },
        },
      )
      .then((res) => {
        const meetingSlots = res?.data?.schedule?.meetingSlots;
        setSelectedRange(
          Object.entries(meetingSlots)
            .filter(([key, value]) => value === true)
            .map(([key]) => key),
        );
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  useEffect(() => {
    console.log(value, "formattedDate");
    getDate();
    props.setTime("");
    props.setDate(value);
  }, [value]);

  const handleChange = (e) => {
    setDisplay(true);
    setValues(e);
    props.setDate(e);
  };

  console.log("object", value);
  return (
    <div
      className="calendary-container"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        minWidth: 0,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          minWidth: 0,
        }}
      >
        <style>{`
      .calendary-layout {
        display: grid;
        grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
        gap: clamp(1rem, 3vw, 2rem);
        width: 100%;
        min-width: 0;
        height: 42vh;
      }
      .calendary-calendar,
      .calendary-timeline {
        min-width: 0;
        height: 100%;
      }
      .calendary-calendar {
        overflow: hidden;
      }
      .calendary-timeline {
        overflow: hidden;
      }
      .calendary-layout .react-calendar {
        border: none !important;
        box-shadow: none !important;
        width: 100%;
        max-width: none;
      }
      .calendary-layout .react-calendar,
      .calendary-layout .react-calendar *,
      .calendary-layout .react-calendar *:before,
      .calendary-layout .react-calendar *:after {
        box-sizing: border-box;
      }
      .calendary-layout .react-calendar__tile {
        height: 36px;
        padding: 0;
      }
        .react-calendar__tile--active {
          // background: #1976d2 !important;
          background: #488257 !important;
          color: white !important;
          border-radius: 10%;
        padding:0px;
         
        }
        .react-calendar__tile--now {
          border-radius: 0;
          background: #e6f0e8 !important;
          color: #488257 !important;
          font-weight: 600;
        }
          .react-calendar__tile:disabled {
    margin-bottom: 4px; /* Adjust as needed */
      
    opacity: 0.5;
  }
    .react-calendar__tile--now.react-calendar__tile--active {
  background: #488257 !important;
  color: white !important;
}
      `}</style>
        <div
          className="calendary-layout"
        >
          <div className="calendary-calendar">
            <Calendar
              onChange={handleChange}
              value={value}
              // selectRange={false} // ✅ disables array usage
              minDate={earliestSelectableDate}
              maxDate={new Date(new Date().setMonth(new Date().getMonth() + 3))}
              tileDisabled={({ date }) =>
                date.getDay() === 0 ||
                date.getDay() === 6 ||
                date < earliestSelectableDate
              }
            />
          </div>
          <div className="calendary-timeline">
            <Timeline
              value={value}
              time={props.setTime}
              timevalue={props.time}
              selectRange={selectRange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Calendary;
